var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnNavManageEnding = function SvgIcnNavManageEnding(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6865 11.8401H11.3132C9.03315 11.8401 7.1665 13.7067 7.1665 15.9867V31.1334C7.1665 33.0668 8.55317 33.8934 10.2465 32.9467L15.4865 30.0267C16.0465 29.7201 16.9532 29.7201 17.4998 30.0267L22.7398 32.9467C24.4332 33.8934 25.8198 33.0668 25.8198 31.1334V15.9867C25.8332 13.7067 23.9665 11.8401 21.6865 11.8401Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8332 15.9867V31.1334C25.8332 33.0668 24.4465 33.8801 22.7532 32.9467L17.5132 30.0267C16.9532 29.7201 16.0465 29.7201 15.4865 30.0267L10.2465 32.9467C8.55317 33.8801 7.1665 33.0668 7.1665 31.1334V15.9867C7.1665 13.7067 9.03315 11.8401 11.3132 11.8401H21.6865C23.9665 11.8401 25.8332 13.7067 25.8332 15.9867Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8332 10.8134V25.9601C33.8332 27.8934 32.4465 28.7067 30.7532 27.7734L25.8332 25.0267V15.9867C25.8332 13.7067 23.9665 11.8401 21.6865 11.8401H15.1665V10.8134C15.1665 8.5334 17.0332 6.66675 19.3132 6.66675H29.6865C31.9665 6.66675 33.8332 8.5334 33.8332 10.8134Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnNavManageEnding, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_nav_manage_ending.2274b77a.svg";
export { ForwardRef as ReactComponent };